import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { HumanisedDate } from 'components/atoms/humanised-date';
import { PrimaryText, SecondaryText, Wrapper } from './styled';

interface RowRecord {
  name?: string;
  startDate?: string | null;
  key?: string | number;
  templateName?: string;
}

export interface TableRecord extends RowRecord {
  children?: Array<RowRecord>;
}

export const columns = [
  {
    title: (
      <FormattedMessage id="projects.phase.import.preview.column.phase_name" />
    ),
    dataIndex: 'name',
    key: 'name',
    className: 'phase',
    render: (value: string, record: TableRecord): React.ReactNode => {
      return (
        <Wrapper>
          <PrimaryText>{value}</PrimaryText>
          <SecondaryText>{record.templateName}</SecondaryText>
        </Wrapper>
      );
    },
  },
  {
    title: <FormattedMessage id="start_date" />,
    dataIndex: 'startDate',
    key: 'startDate',
    width: '20%',
    className: 'start-date',
    render: (value: string): React.ReactNode => (
      <HumanisedDate timestamp={moment(value)} />
    ),
  },
];
